import { styled } from '@mui/material';

import { memo, useState } from 'react';

import { Skeleton } from '@app-velocity/ui';

const StyledAppraisalPreloader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  cursor: 'pointer',
  gap: theme.spacing(2),
}));

const getRandomHeight = () => {
  return Math.round(40 + Math.random() * 15);
};

export const AppraisalPreloader = memo(() => {
  const [heights] = useState(() => [
    getRandomHeight(),
    getRandomHeight(),
    getRandomHeight(),
  ]);

  return (
    <StyledAppraisalPreloader>
      <Skeleton height={20} width={150} margin="0" variant="light" />
      <Skeleton height={heights[0]} margin="0" variant="light" />
      <Skeleton height={heights[1]} margin="0" variant="light" />
      <Skeleton height={heights[2]} margin="0" variant="light" />
    </StyledAppraisalPreloader>
  );
});
